const glSkeletor = {
  skeletor: {
    bind(el, binding) {
      let eventType = binding.arg;
      let action = binding.value;
      el.addEventListener(eventType, (component) => {
        action(component.target.id, component.detail.value, component.detail.dirty);
      });
    },
    unbind: (el, binding) => {
      let eventType = binding.arg;
      let action = binding.value;
      el.removeEventListener(eventType, action);
    }
  }
};

export { glSkeletor };
